export const ttsPreview = {
    language: "en",
    text: "This is a quick preview of this ReelMagic AI voice.",
    version: 1,
};
export const openRouterTtsModelId = "hexgrad/kokoro-82m";
export const defaultTtsModelId = "elevenlabs/eleven-flash-v2.5";
export const defaultTtsVoiceId = "elevenlabs-adam";
export const supportedTtsProviderVoices = [
    "alloy",
    "ash",
    "ballad",
    "cedar",
    "coral",
    "echo",
    "fable",
    "marin",
    "nova",
    "onyx",
    "sage",
    "shimmer",
    "verse",
];
function buildPreviewAssetKey(modelId, voiceId) {
    const slug = (value) => value
        .trim()
        .toLowerCase()
        .replaceAll("/", "-")
        .replaceAll(/[^a-z0-9._-]/g, "-")
        .replaceAll(/-+/g, "-")
        .replaceAll(/^-|-$/g, "");
    return `assets/audio/voice-previews/v${ttsPreview.version}/${slug(modelId)}/${slug(voiceId)}.m4a`;
}
function voice(input) {
    return {
        ...input,
        language: "en",
        previewAssetKey: buildPreviewAssetKey(input.modelId, input.id),
    };
}
export const elevenLabsModelIds = ["elevenlabs/eleven-v4", "elevenlabs/eleven-flash-v2.5"];
export function isElevenLabsModelId(value) {
    return elevenLabsModelIds.some((id) => id === value);
}
export function getPublicElevenLabsVoiceId(value) {
    const match = /^elevenlabs-public-([a-zA-Z0-9]{20})$/.exec(value);
    return match?.[1] ?? null;
}
const elevenLabsVoiceNames = [
    "george", "sarah", "adam", "alice", "bella", "bill", "brian",
    "callum", "charlie", "chris", "daniel", "eric", "harry", "jessica",
    "laura", "liam", "lily", "matilda", "river", "roger", "will",
];
function elevenLabsVoices(modelId) {
    return elevenLabsVoiceNames.map((name) => voice({
        id: `elevenlabs-${name}`,
        label: name[0].toUpperCase() + name.slice(1),
        modelId,
        providerVoiceId: name,
    }));
}
const kokoroVoices = [
    voice({ id: "alloy", label: "Alloy", modelId: openRouterTtsModelId, providerVoiceId: "af_alloy" }),
    voice({ id: "ash", label: "Ash", modelId: openRouterTtsModelId, providerVoiceId: "am_michael" }),
    voice({ id: "ballad", label: "Ballad", modelId: openRouterTtsModelId, providerVoiceId: "af_aoede" }),
    voice({ id: "cedar", label: "Cedar", modelId: openRouterTtsModelId, providerVoiceId: "am_fenrir" }),
    voice({ id: "coral", label: "Coral", modelId: openRouterTtsModelId, providerVoiceId: "af_bella" }),
    voice({ id: "echo", label: "Echo", modelId: openRouterTtsModelId, providerVoiceId: "am_echo" }),
    voice({ id: "fable", label: "Fable", modelId: openRouterTtsModelId, providerVoiceId: "bm_fable" }),
    voice({ id: "marin", label: "Marin", modelId: openRouterTtsModelId, providerVoiceId: "af_heart" }),
    voice({ id: "nova", label: "Nova", modelId: openRouterTtsModelId, providerVoiceId: "af_nova" }),
    voice({ id: "onyx", label: "Onyx", modelId: openRouterTtsModelId, providerVoiceId: "am_onyx" }),
    voice({ id: "sage", label: "Sage", modelId: openRouterTtsModelId, providerVoiceId: "af_sarah" }),
    voice({ id: "shimmer", label: "Shimmer", modelId: openRouterTtsModelId, providerVoiceId: "af_sky" }),
    voice({ id: "verse", label: "Verse", modelId: openRouterTtsModelId, providerVoiceId: "am_puck" }),
    voice({ id: "kokoro-af-jessica", label: "Jessica", modelId: openRouterTtsModelId, providerVoiceId: "af_jessica" }),
    voice({ id: "kokoro-af-kore", label: "Kore", modelId: openRouterTtsModelId, providerVoiceId: "af_kore" }),
    voice({ id: "kokoro-af-nicole", label: "Nicole", modelId: openRouterTtsModelId, providerVoiceId: "af_nicole" }),
    voice({ id: "kokoro-af-river", label: "River", modelId: openRouterTtsModelId, providerVoiceId: "af_river" }),
    voice({ id: "kokoro-am-adam", label: "Adam", modelId: openRouterTtsModelId, providerVoiceId: "am_adam" }),
    voice({ id: "kokoro-am-eric", label: "Eric", modelId: openRouterTtsModelId, providerVoiceId: "am_eric" }),
    voice({ id: "kokoro-am-liam", label: "Liam", modelId: openRouterTtsModelId, providerVoiceId: "am_liam" }),
    voice({ id: "kokoro-bf-alice", label: "Alice", modelId: openRouterTtsModelId, providerVoiceId: "bf_alice" }),
    voice({ id: "kokoro-bf-emma", label: "Emma", modelId: openRouterTtsModelId, providerVoiceId: "bf_emma" }),
    voice({ id: "kokoro-bf-isabella", label: "Isabella", modelId: openRouterTtsModelId, providerVoiceId: "bf_isabella" }),
    voice({ id: "kokoro-bf-lily", label: "Lily", modelId: openRouterTtsModelId, providerVoiceId: "bf_lily" }),
    voice({ id: "kokoro-bm-daniel", label: "Daniel", modelId: openRouterTtsModelId, providerVoiceId: "bm_daniel" }),
    voice({ id: "kokoro-bm-george", label: "George", modelId: openRouterTtsModelId, providerVoiceId: "bm_george" }),
    voice({ id: "kokoro-bm-lewis", label: "Lewis", modelId: openRouterTtsModelId, providerVoiceId: "bm_lewis" }),
];
const grokVoiceTtsModelId = "x-ai/grok-voice-tts-1.0";
const grokVoiceTtsVoices = [
    voice({ id: "grok-eve", label: "Eve", modelId: grokVoiceTtsModelId, providerVoiceId: "eve" }),
    voice({ id: "grok-ara", label: "Ara", modelId: grokVoiceTtsModelId, providerVoiceId: "ara" }),
    voice({ id: "grok-rex", label: "Rex", modelId: grokVoiceTtsModelId, providerVoiceId: "rex" }),
    voice({ id: "grok-sal", label: "Sal", modelId: grokVoiceTtsModelId, providerVoiceId: "sal" }),
    voice({ id: "grok-leo", label: "Leo", modelId: grokVoiceTtsModelId, providerVoiceId: "leo" }),
];
const maiVoiceFlashModelId = "microsoft/mai-voice-2-flash";
const maiVoiceFlashVoices = [
    voice({
        id: "mai-flash-harper",
        label: "Harper",
        modelId: maiVoiceFlashModelId,
        providerVoiceId: "en-US-Harper:MAI-Voice-2-Flash",
    }),
    voice({
        id: "mai-flash-ethan",
        label: "Ethan",
        modelId: maiVoiceFlashModelId,
        providerVoiceId: "en-US-Ethan:MAI-Voice-2-Flash",
    }),
    voice({
        id: "mai-flash-olivia",
        label: "Olivia",
        modelId: maiVoiceFlashModelId,
        providerVoiceId: "en-US-Olivia:MAI-Voice-2-Flash",
    }),
];
const qwenAudioFlashModelId = "qwen/qwen-audio-3.0-tts-flash";
const qwenAudioFlashVoices = [
    voice({
        id: "qwen-flash-loongjohn",
        label: "John",
        modelId: qwenAudioFlashModelId,
        providerVoiceId: "loongjohn",
    }),
    voice({
        id: "qwen-flash-loongeva",
        label: "Eva",
        modelId: qwenAudioFlashModelId,
        providerVoiceId: "loongeva_v3.6",
    }),
    voice({ id: "qwen-flash-longanfengyue", label: "Feng Yue", modelId: qwenAudioFlashModelId, providerVoiceId: "longanfengyue" }),
    voice({ id: "qwen-flash-longanyuanfei", label: "Yuan Fei", modelId: qwenAudioFlashModelId, providerVoiceId: "longanyuanfei" }),
    voice({ id: "qwen-flash-longanlingxi", label: "Ling Xi", modelId: qwenAudioFlashModelId, providerVoiceId: "longanlingxi" }),
];
const minimaxSpeechTurboModelId = "minimax/speech-2.8-turbo";
const minimaxSpeechTurboVoices = [
    voice({
        id: "minimax-turbo-wise-woman",
        label: "Wise Woman",
        modelId: minimaxSpeechTurboModelId,
        providerVoiceId: "Wise_Woman",
    }),
    voice({
        id: "minimax-turbo-friendly-person",
        label: "Friendly Person",
        modelId: minimaxSpeechTurboModelId,
        providerVoiceId: "Friendly_Person",
    }),
    voice({
        id: "minimax-turbo-deep-voice-man",
        label: "Deep Voice Man",
        modelId: minimaxSpeechTurboModelId,
        providerVoiceId: "Deep_Voice_Man",
    }),
    voice({
        id: "minimax-turbo-calm-woman",
        label: "Calm Woman",
        modelId: minimaxSpeechTurboModelId,
        providerVoiceId: "Calm_Woman",
    }),
    voice({ id: "minimax-turbo-santa-claus", label: "Santa Claus", modelId: minimaxSpeechTurboModelId, providerVoiceId: "Santa_Claus" }),
    voice({ id: "minimax-turbo-grinch", label: "Grinch", modelId: minimaxSpeechTurboModelId, providerVoiceId: "Grinch" }),
    voice({ id: "minimax-turbo-rudolph", label: "Rudolph", modelId: minimaxSpeechTurboModelId, providerVoiceId: "Rudolph" }),
    voice({ id: "minimax-turbo-arnold", label: "Arnold", modelId: minimaxSpeechTurboModelId, providerVoiceId: "Arnold" }),
    voice({ id: "minimax-turbo-charming-santa", label: "Charming Santa", modelId: minimaxSpeechTurboModelId, providerVoiceId: "Charming_Santa" }),
    voice({ id: "minimax-turbo-charming-lady", label: "Charming Lady", modelId: minimaxSpeechTurboModelId, providerVoiceId: "Charming_Lady" }),
    voice({ id: "minimax-turbo-sweet-girl", label: "Sweet Girl", modelId: minimaxSpeechTurboModelId, providerVoiceId: "Sweet_Girl" }),
    voice({ id: "minimax-turbo-cute-elf", label: "Cute Elf", modelId: minimaxSpeechTurboModelId, providerVoiceId: "Cute_Elf" }),
    voice({ id: "minimax-turbo-attractive-girl", label: "Attractive Girl", modelId: minimaxSpeechTurboModelId, providerVoiceId: "Attractive_Girl" }),
    voice({ id: "minimax-turbo-serene-woman", label: "Serene Woman", modelId: minimaxSpeechTurboModelId, providerVoiceId: "Serene_Woman" }),
    voice({ id: "minimax-turbo-english-trustworthy-man", label: "Trustworthy Man", modelId: minimaxSpeechTurboModelId, providerVoiceId: "English_Trustworthy_Man" }),
    voice({ id: "minimax-turbo-english-graceful-lady", label: "Graceful Lady", modelId: minimaxSpeechTurboModelId, providerVoiceId: "English_Graceful_Lady" }),
    voice({ id: "minimax-turbo-aussie-bloke", label: "Aussie Bloke", modelId: minimaxSpeechTurboModelId, providerVoiceId: "English_Aussie_Bloke" }),
    voice({ id: "minimax-turbo-whispering-girl", label: "Whispering Girl", modelId: minimaxSpeechTurboModelId, providerVoiceId: "English_Whispering_girl" }),
    voice({ id: "minimax-turbo-diligent-man", label: "Diligent Man", modelId: minimaxSpeechTurboModelId, providerVoiceId: "English_Diligent_Man" }),
    voice({ id: "minimax-turbo-gentle-voiced-man", label: "Gentle-voiced Man", modelId: minimaxSpeechTurboModelId, providerVoiceId: "English_Gentle-voiced_man" }),
];
const voxtralMiniTtsModelId = "mistralai/voxtral-mini-tts-2603";
const voxtralMiniTtsVoices = [
    voice({
        id: "voxtral-paul-neutral",
        label: "Paul (Neutral)",
        modelId: voxtralMiniTtsModelId,
        providerVoiceId: "en_paul_neutral",
    }),
    voice({
        id: "voxtral-jane-neutral",
        label: "Jane (Neutral)",
        modelId: voxtralMiniTtsModelId,
        providerVoiceId: "gb_jane_neutral",
    }),
    voice({
        id: "voxtral-jane-confident",
        label: "Jane (Confident)",
        modelId: voxtralMiniTtsModelId,
        providerVoiceId: "gb_jane_confident",
    }),
    voice({
        id: "voxtral-jane-curious",
        label: "Jane (Curious)",
        modelId: voxtralMiniTtsModelId,
        providerVoiceId: "gb_jane_curious",
    }),
    voice({ id: "voxtral-paul-sad", label: "Paul (Sad)", modelId: voxtralMiniTtsModelId, providerVoiceId: "en_paul_sad" }),
    voice({ id: "voxtral-paul-happy", label: "Paul (Happy)", modelId: voxtralMiniTtsModelId, providerVoiceId: "en_paul_happy" }),
    voice({ id: "voxtral-paul-frustrated", label: "Paul (Frustrated)", modelId: voxtralMiniTtsModelId, providerVoiceId: "en_paul_frustrated" }),
    voice({ id: "voxtral-paul-excited", label: "Paul (Excited)", modelId: voxtralMiniTtsModelId, providerVoiceId: "en_paul_excited" }),
    voice({ id: "voxtral-paul-confident", label: "Paul (Confident)", modelId: voxtralMiniTtsModelId, providerVoiceId: "en_paul_confident" }),
    voice({ id: "voxtral-paul-cheerful", label: "Paul (Cheerful)", modelId: voxtralMiniTtsModelId, providerVoiceId: "en_paul_cheerful" }),
    voice({ id: "voxtral-paul-angry", label: "Paul (Angry)", modelId: voxtralMiniTtsModelId, providerVoiceId: "en_paul_angry" }),
    voice({ id: "voxtral-jane-sarcasm", label: "Jane (Sarcasm)", modelId: voxtralMiniTtsModelId, providerVoiceId: "gb_jane_sarcasm" }),
    voice({ id: "voxtral-jane-confused", label: "Jane (Confused)", modelId: voxtralMiniTtsModelId, providerVoiceId: "gb_jane_confused" }),
    voice({ id: "voxtral-jane-shameful", label: "Jane (Shameful)", modelId: voxtralMiniTtsModelId, providerVoiceId: "gb_jane_shameful" }),
    voice({ id: "voxtral-jane-sad", label: "Jane (Sad)", modelId: voxtralMiniTtsModelId, providerVoiceId: "gb_jane_sad" }),
    voice({ id: "voxtral-jane-jealousy", label: "Jane (Jealous)", modelId: voxtralMiniTtsModelId, providerVoiceId: "gb_jane_jealousy" }),
    voice({ id: "voxtral-jane-frustrated", label: "Jane (Frustrated)", modelId: voxtralMiniTtsModelId, providerVoiceId: "gb_jane_frustrated" }),
    voice({ id: "voxtral-oliver-neutral", label: "Oliver (Neutral)", modelId: voxtralMiniTtsModelId, providerVoiceId: "gb_oliver_neutral" }),
    voice({ id: "voxtral-oliver-sad", label: "Oliver (Sad)", modelId: voxtralMiniTtsModelId, providerVoiceId: "gb_oliver_sad" }),
    voice({ id: "voxtral-oliver-excited", label: "Oliver (Excited)", modelId: voxtralMiniTtsModelId, providerVoiceId: "gb_oliver_excited" }),
    voice({ id: "voxtral-oliver-curious", label: "Oliver (Curious)", modelId: voxtralMiniTtsModelId, providerVoiceId: "gb_oliver_curious" }),
    voice({ id: "voxtral-oliver-confident", label: "Oliver (Confident)", modelId: voxtralMiniTtsModelId, providerVoiceId: "gb_oliver_confident" }),
    voice({ id: "voxtral-oliver-cheerful", label: "Oliver (Cheerful)", modelId: voxtralMiniTtsModelId, providerVoiceId: "gb_oliver_cheerful" }),
    voice({ id: "voxtral-oliver-angry", label: "Oliver (Angry)", modelId: voxtralMiniTtsModelId, providerVoiceId: "gb_oliver_angry" }),
];
export const ttsModelOptions = [
    {
        availability: "enabled",
        billing: { type: "input_character", usdPerCharacter: 0.00008 },
        description: "Expressive narration with natural emotion and delivery.",
        id: elevenLabsModelIds[0],
        label: "ElevenLabs Eleven v4",
        providerId: "openrouter",
        voices: elevenLabsVoices(elevenLabsModelIds[0]),
    },
    {
        availability: "enabled",
        billing: { type: "input_character", usdPerCharacter: 0.00004 },
        description: "Fast, natural speech at a lower cost.",
        id: elevenLabsModelIds[1],
        label: "ElevenLabs Flash v2.5",
        providerId: "openrouter",
        voices: elevenLabsVoices(elevenLabsModelIds[1]),
    },
    {
        availability: "enabled",
        billing: { type: "input_character", usdPerCharacter: 0.000015 },
        description: "Expressive multilingual speech with built-in voices and style controls.",
        id: grokVoiceTtsModelId,
        label: "Grok Voice TTS 1.0",
        providerId: "openrouter",
        voices: grokVoiceTtsVoices,
    },
    {
        availability: "enabled",
        billing: { type: "input_character", usdPerCharacter: 0.00000062 },
        description: "Fast, cost-effective narration with a broad voice range.",
        id: openRouterTtsModelId,
        label: "Kokoro 82M",
        providerId: "openrouter",
        voices: kokoroVoices,
    },
    {
        availability: "enabled",
        billing: { type: "input_character", usdPerCharacter: 0.000015 },
        description: "Fast, expressive speech for narration and interactive audio.",
        id: maiVoiceFlashModelId,
        label: "MAI-Voice-2-Flash",
        providerId: "openrouter",
        voices: maiVoiceFlashVoices,
    },
    {
        availability: "enabled",
        billing: { type: "input_character", usdPerCharacter: 0.000015 },
        description: "Fast multilingual speech with natural style control.",
        id: qwenAudioFlashModelId,
        label: "Qwen Audio 3.0 TTS Flash",
        providerId: "openrouter",
        voices: qwenAudioFlashVoices,
    },
    {
        availability: "enabled",
        billing: { type: "input_character", usdPerCharacter: 0.00006 },
        description: "Fast, expressive speech with a broad voice catalogue.",
        id: minimaxSpeechTurboModelId,
        label: "MiniMax Speech 2.8 Turbo",
        providerId: "openrouter",
        voices: minimaxSpeechTurboVoices,
    },
    {
        availability: "enabled",
        billing: { type: "input_character", usdPerCharacter: 0.000016 },
        description: "Natural multilingual speech with emotion-tagged voices.",
        id: voxtralMiniTtsModelId,
        label: "Voxtral Mini TTS",
        providerId: "openrouter",
        voices: voxtralMiniTtsVoices,
    },
];
export const ttsVoiceOptions = ttsModelOptions.flatMap((model) => model.voices);
const ttsModelsById = new Map(ttsModelOptions.map((model) => [model.id, model]));
export function getTtsModelOption(modelId) {
    return ttsModelsById.get(modelId) ?? null;
}
export function getTtsVoiceOption(modelId, voiceId) {
    const publicVoiceId = getPublicElevenLabsVoiceId(voiceId);
    if (isElevenLabsModelId(modelId) && publicVoiceId) {
        // The server must check that the user saved this voice before generation.
        return voice({ id: voiceId, label: "Public ElevenLabs voice", modelId, providerVoiceId: publicVoiceId });
    }
    return (getTtsModelOption(modelId)?.voices.find((entry) => entry.id === voiceId) ??
        null);
}
export function isEnabledTtsModelId(value) {
    return (typeof value === "string" &&
        getTtsModelOption(value)?.availability === "enabled");
}
export function isEnabledTtsSelection(input) {
    return (typeof input.modelId === "string" &&
        typeof input.voiceId === "string" &&
        isEnabledTtsModelId(input.modelId) &&
        getTtsVoiceOption(input.modelId, input.voiceId) !== null);
}
export function isSupportedTtsProviderVoiceId(value) {
    return supportedTtsProviderVoices.some((voiceId) => voiceId === value);
}
